class SearchResult {
	constructor(docs, other) {
		if (!docs) {
			throw new Error('Invalid docs');
		}
		this.docs = docs;
		this.other = other;
		Object.freeze(this); // Make immutable
	}

	isEmpty() {
		return this.docs.length === 0 && this.other == null;
	}
	static Empty() {
		return new SearchResult([], null);
	}
}
export default SearchResult;